import React from "react";
import BaseListPage from "../../../../base/BaseListPage";
import { Button, InfiniteScroll, Progress } from "nq-component";
import CardView from "../../../../components/common/CardView";
import Table from "../../../../components/Table";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../usecases/object";
import TrainingListForm from "../../Training/TrainingTable/training-list-form/TrainingListForm";
import Search from "../../../../components/Search";
import SearchSelect from "../../../../components/searchSelect/SearchSelect";
import InputFactory from "../../../../components/InputFactory";
import DateRangePicker from "../../../../components/common/DateRangePicker";
import TrainingReportPresenter from "./TrainingReportPresenter";

class TrainingCost extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new TrainingReportPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
    this.state = {
      progress: false,
      objects: [],
      method: [],
      type: [],
      status: [],
      filteredMethod: "",
      filteredType: "",
      filteredStatus: "",
      count: 0,
      limit: 10,
      current: 1,
    };
  }

  async componentDidMount() {
    this.presenter.componentDidMount();
    const status = await findObjectUseCase().execute("management_training");
    const type = await findObjectUseCase().execute("management_training");
    const method = await findObjectUseCase().execute("management_training");

    this.setState({ status, type, method });
  }

  getCollectionName() {
    return "management_training";
  }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit({});
    return objects;
  }

  onChangeOption(field, value) {
    this.setState({ [field]: value });
    if (field === "filteredStatus") {
      this.presenter.onChangeFilter("String", value, "stats");
    } else if (field === "filteredType") {
      this.presenter.onChangeFilter("String", value, "trainingType");
    } else if (field === "filteredMethod") {
      this.presenter.onChangeFilter("String", value, "trainingMethod");
    }
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, count, loading, progress, current, limit } = this.state;

    if (!schema) return <Progress />;
    const predefinedMethods = ["Virtual", "Face to Face"];
    const predefinedStatus = ["New", "Ongoing", "Done", "Cancelled"];
    const predefinedTypes = [
      "Foundation",
      "Managerial",
      "Supervisory",
      "Technical",
    ];

    const GenerateExcel = () => {
      const { objects } = this.state;
      let csvContent = "Trainings,Date,Time,Methods,Budgets,Costs\n"; // CSV header

      const escapeCsvValue = (value) => {
        if (typeof value === "string" && value.includes(",")) {
          return `"${value}"`;
        }
        return value;
      };

      objects.forEach((item) => {
        const training = escapeCsvValue(item.training || "");
        const date = escapeCsvValue(item.date || "");
        const time = escapeCsvValue(item.time || "");
        const trainingMethod = escapeCsvValue(item.trainingMethod || "");
        const budgets = escapeCsvValue(item.budgets || "");
        const costs = escapeCsvValue(item.costs || "");
        csvContent += `${training},${date},${time},${trainingMethod},${budgets},${costs}\n`;
      });

      // Ensure the CSV is saved with UTF-8 encoding
      const blob = new Blob([`\uFEFF ${csvContent}`], {
        type: "text/csv;charset=utf-8;",
      });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `Training Report.csv`);
      document.body.appendChild(link);
      link.click();

      // Clean up
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    };
    console.log("OBJE: ", objects);

    return (
      <>
        <div className="overflow-auto">
          <InfiniteScroll
            className="h-100"
            loadMore={this.loadMore.bind(this)}
            hasMore={!progress && count > objects.length}
          >
            <div>
              <CardView style={{ borderRadius: 0 }}>
                <div className="row d-flex align-items-center">
                  <div className="col-md-6 mt-1 ">
                    <Search
                      schemas={this.getSchemas()}
                      onSubmit={this.searchSubmit.bind(this)}
                      fields={schema.fields}
                    />
                  </div>
                  <div className="col-md-6 mt-1 border-box">
                    <DateRangePicker
                      fields={["datefrom", "dateto", ""]}
                      onFilter={(filterObj) => {
                        this.searchSubmit(filterObj);
                      }}
                    />
                  </div>
                </div>
              </CardView>
              <br></br>
              <CardView>
                <div className="row">
                  <div className="col-sm-4 mt-1">
                    {/* Filtering For Training Method */}
                    <SearchSelect
                      value={this.state.filteredMethod}
                      placeholder="Select Method"
                      onChange={(value) =>
                        this.onChangeOption("filteredMethod", value)
                      }
                      onClickClear={() =>
                        this.onChangeOption("filteredMethod", "")
                      }
                      options={[
                        ...predefinedMethods.map((trainingMethod) => ({
                          label: trainingMethod,
                          value: trainingMethod,
                        })),
                      ]}
                    />
                  </div>
                  {/* Filtering For Training Type */}
                  <div className="col-sm-4 mt-1">
                    <SearchSelect
                      value={this.state.filteredType}
                      placeholder="Select Type"
                      onChange={(value) =>
                        this.onChangeOption("filteredType", value)
                      }
                      onClickClear={() =>
                        this.onChangeOption("filteredType", "")
                      }
                      options={[
                        ...predefinedTypes.map((trainingType) => ({
                          label: trainingType,
                          value: trainingType,
                        })),
                      ]}
                    />
                  </div>
                  {/* Filtering For Training Status */}
                  <div className="col-sm-4 mt-1">
                    <SearchSelect
                      value={this.state.filteredStatus}
                      placeholder="Select Status"
                      onChange={(value) =>
                        this.onChangeOption("filteredStatus", value)
                      }
                      onClickClear={() =>
                        this.onChangeOption("filteredStatus", "")
                      }
                      options={[
                        ...predefinedStatus.map((stats) => ({
                          label: stats,
                          value: stats,
                        })),
                      ]}
                    />
                  </div>
                </div>
              </CardView>

              <div style={{ marginTop: "15px", width: "100%" }}>
                <CardView style={{ borderRadius: 0 }}>
                  <div className="d-flex align-items-center">
                    <h4 className="text-primary">Training Cost</h4>
                    <div style={{ marginLeft: "auto" }}>
                      <Button
                        className="btn bg-white border border-primary text-primary"
                        onClick={() => GenerateExcel()}
                      >
                        <i className="bi bi-filetype-csv" /> CSV
                      </Button>
                    </div>
                  </div>
                </CardView>
              </div>

              <Table
                progress={loading}
                refetch={this.refetchData.bind(this)}
                fields={schema.fields}
                objects={objects}
                collection={schema}
                count={count}
                limit={limit}
                current={current}
                loadPagination={this.onClickPagination.bind(this)}
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key];
                    if (options.read === false) {
                      acc.push(key);
                    }
                    switch (options._type || options.type) {
                      case "Relation":
                      case "Array":
                      case "Object":
                      case "File":
                        acc.push(key);
                        break;
                      default:
                    }
                    return acc;
                  },
                  [
                    "Id",
                    "Created At",
                    "Updated At",
                    "targetcompetency",
                    "time",
                    // "stats",
                    "datefrom",
                    "participants",
                    "dateto",
                  ]
                )}
                onClickItem={this.onClickItem.bind(this)}
              />
            </div>
          </InfiniteScroll>
        </div>
        {this.state.isTrainingFormOpen && (
          <TrainingListForm
            closeTrainingForm={() =>
              this.setState({ isTrainingFormOpen: false })
            }
            refetchData={this.refetchData.bind(this)}
            object={this.state.object}
            action={this.state.action}
          />
        )}
      </>
    );
  }
}

export default TrainingCost;
